import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getInvestmentVehicleRelatedPeople } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { toRelatedPersonCards } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestmentVehicleDetails/components/RelatedPeopleCard/relatedPeople.utils.ts';
import { RelatedPersonCardRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestmentVehicleDetails/components/RelatedPeopleCard/relatedPeople.types.ts';

interface Result {
	cards: RelatedPersonCardRow[];
	isLoading: boolean;
	isError: boolean;
}

export const useVehicleRelatedPeople = ({
	mipId,
	personId,
}: {
	mipId: string;
	personId: string;
}): Result => {
	const relatedPeopleQuery = useQuery({
		queryKey: [
			API_PATHS.MIP_INVESTOR_INVESTMENT_VEHICLE_PERSONID_RELATED_PEOPLE_GET,
			{ personId, mipId },
		],
		queryFn: ({ signal }) =>
			getInvestmentVehicleRelatedPeople(
				API_PATHS.MIP_INVESTOR_INVESTMENT_VEHICLE_PERSONID_RELATED_PEOPLE_GET,
				{ personId },
				signal
			),
	});

	const payload = relatedPeopleQuery.data?.payload;
	const cards = useMemo(() => toRelatedPersonCards(payload), [payload]);

	return {
		cards,
		isLoading: relatedPeopleQuery.isPending,
		isError: relatedPeopleQuery.isError,
	};
};
